import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  confirmationModalContent: {
    display: "flex",
    gap: 10,
    flexDirection: "column" as const,
    background: theme.palette.white,
    padding: "0 20px 20px 20px",
    borderRadius: "8px",
    width: "600px",
    position: "relative" as const,
    textAlign: "left" as const,
  },

  confirmationModalMessage: {
    marginBottom: "16px",
    color: theme.palette.neutralSecondary,
    fontSize: "15px",
    textAlign: "left" as const,
  },

  confirmationModalErrorBox: {
    maxWidth: "600px",
    color: theme.palette.redDark,
    fontWeight: 400,
    fontSize: "13px",
    marginTop: "8px",
    whiteSpace: "pre-wrap" as const,
    background: `${theme.palette.redDark}0D`, // 5% opacity
    border: `1px solid ${theme.palette.redDark}`,
    borderRadius: "6px",
    padding: "12px",
    maxHeight: "180px",
    overflowY: "auto" as const,
    overflowX: "auto" as const,
    fontFamily: "Consolas, monospace",
    boxShadow: `0 1px 4px 0 ${theme.palette.redDark}14`, // 8% opacity
  },

  confirmationModalDetailsBox: {
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
    padding: "16px",
    fontSize: "14px",
    marginBottom: "10px",
    textAlign: "left" as const,
  },

  confirmationModalBranchInfo: {
    color: theme.palette.neutralPrimary,
  },

  confirmationModalBranchLink: {
    fontWeight: 500,
    color: theme.palette.themePrimary,
    textDecoration: "underline",
  },

  confirmationModalBranchName: {
    fontWeight: 500,
  },

  confirmationModalBranchMain: {
    fontWeight: 500,
  },

  confirmationModalPanelTitle: {
    fontWeight: 600,
    fontSize: "16px",
    marginBottom: "8px",
    textAlign: "left" as const,
  },

  confirmationModalFilesBox: {
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
    paddingLeft: 10,
    fontSize: "14px",
    marginBottom: "10px",
    maxHeight: "400px",
    overflowY: "auto" as const,
    textAlign: "left" as const,
  },

  confirmationModalFileContent: {
    background: theme.palette.neutralLighter,
    borderRadius: "4px",
    padding: "12px",
    fontSize: "13px",
    overflowX: "auto" as const,
    maxHeight: "200px",
    overflowY: "auto" as const,
    margin: "0",
  },

  confirmationModalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },

  confirmationModalAccordionHeader: {
    "& button": {
      color: theme.palette.neutralPrimary,
      display: "flex",
      fontSize: "15px",
      gap: 5,
    },
  },
});

export { styles };
